<div class="ngx-image-box-editor">
  <div class="row">
    <div [ngClass]="{ 'col-12': !isMenuOpened, 'col-7': isMenuOpened }">
      <div #mainContainer>
        <div class="image-box-editor">
          <!-- konva.js container -->
          <div id="konva-stage-parent">
            <div id="konva-container"></div>
          </div>
          <!-- <div *ngIf="!annotations">Loading...</div> -->

          <!-- annotation popover -->
          <div id="ann-popover" class="image-annotation-popover" [hidden]="!showAnnotationPopover" [@inOutAnimation]>
            <button class="close-btn" nbButton ghost (click)="closePopover()">
              <nb-icon icon="close"></nb-icon>
            </button>
            <div class="content" *ngIf="selectedAnnotation">
              <img class="mr-2" src="/assets/icons/edit-icon.svg" />Edit
              <!-- <h2 class="title">Edit</h2> -->
              <div class="editor">
                <div>
                  <input  #annotationTextInput type="text" nbInput status="primary" fullWidth placeholder="Edit"
                    [value]="selectedAnnotation.description">
                  <div class="button-group mt-3">
                    <button nbButton size="small" (click)="updateAnnotation(annotationTextInput.value)"
                      class="mr-2" >
                      <!-- <div *ngIf="!editorStatus || consent.consentFileId !== selectedannotationCellId">{{consent.selectedannotationCellId}}</div>> -->
                      <nb-icon icon="save"></nb-icon>
                    </button>
                    <button title="Delete" nbButton status="danger" size="small" [nbPopover]="actionBtnList"
                      nbPopoverPlacement="bottom">
                      <nb-icon icon="trash-outline"></nb-icon>
                    </button>
                    <ng-template #actionBtnList>
                      <div style="padding: 5px;width: 200px;" class="action-button-wrapper">
                        <ng-container>
                          <button style="margin: 2px;" nbButton outline size="small" fullWidth
                            (click)="removeSelectedAnnotation('CELL')">
                            CELL
                          </button>
                          <button style="margin: 2px;" nbButton outline size="small" status="warning" fullWidth
                            (click)="removeSelectedAnnotation('ROW')">
                            ROW
                          </button>
                          <button style="margin: 2px;" nbButton outline size="small" status="danger" fullWidth
                            (click)="removeSelectedAnnotation('TABLE')">
                            TABLE
                          </button>
                        </ng-container>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>

            <!-- annotation code -->
            <div class="collapse show" *ngIf="showAnnotationCode">
              <div class="card card-body">
                <pre>{{ selectedAnnotation | json }}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>